var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isMaintencanceMode)?[_c('Maintenance')]:(_vm.isExpertsRoute)?_c('Experts',[_c('router-view')],1):_c('Default',[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }